// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blob-actions-container {
  display: flex; /* Enable flexbox */
  justify-content: space-between;
}

.blob-action-button {
  flex: 1 1; /* Allow children to grow and fill available space */
  margin-top: 10px;
  background: var(--hover-color);
  position: relative;
}

.blob-action-button:hover {
  background: var(--secondary-color);
}

#blob-download-button {
  margin-left: 10px;
}

.generate-button-container {
  position: relative;
  display: inline-block;
  cursor: pointer;
  width: 100%; 
  margin-bottom: 5px;
}

.generate-button-container .tooltip {
  visibility: hidden;
  width: 220px;
  background-color: var(--highlight-color); /* Purple background like in the image */
  color: var(--background-color);
  text-align: center;
  border-radius: 6px;
  padding: 10px;
  position: absolute;
  z-index: 1;
  top: 130%; /* Position it below the button */
  left: 83%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s;
}

.generate-button-container .tooltip-caret {
  position: absolute;
  top: -6px; /* Position the caret right below the tooltip */
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid var(--highlight-color); /* Same color as the tooltip background */
}

.generate-button-container:hover .tooltip {
  visibility: visible;
  opacity: 1;
}

.blob-action-button .tooltip {
  visibility: hidden;
  width: 220px;
  background-color: var(--highlight-color); /* Purple background like in the image */
  color: var(--background-color);
  text-align: center;
  border-radius: 6px;
  padding: 10px;
  position: absolute;
  z-index: 1;
  top: 130%; 
  transform: translateX(15%);
  opacity: 0;
  transition: opacity 0.3s;
}

.blob-action-button .tooltip-caret {
  position: absolute;
  top: -6px; /* Position the caret right below the tooltip */
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid var(--highlight-color); /* Same color as the tooltip background */
}

.blob-action-button:hover .tooltip {
  visibility: visible;
  opacity: 1;
}

.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Loading Animation Container */
.loading-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 90vh;
  background-color: var(--background-color); /* Adjust background color as needed */
  color: var(--text-color); /* Text color */
}

.loading-text {
  font-size: 1.5rem;
  text-align: center;
  font-family: 'Eastlane Medium', sans-serif;
  margin-bottom: 30px; /* Space between text and spinner */
}

.spinner {
  border: 8px solid var(--primary-color); /* Light grey background */
  border-top: 8px solid var(--background-color); /* Blue color for the spinning part */
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-subtext {
  font-size: 1.2rem;
  margin-top: 20px; /* Space between spinner and subtext */
  color: var(--secondary-text-color);
  text-align: center;
  font-family: "Riforma Regular", "Montserrat", sans-serif; 
}

.fyMonth {
  float: right;
  color: var(--highlight-color);
  font-family: "Riforma Bold Italic", "Montserrat", sans-serif; 
  font-weight: 800;
}

.model-generator-container {
  padding: 35px;
  border-radius: 20px;
  background: var(--tertiary-background-color);
  box-shadow: 0 2px 7px 0 rgba(0,0,0,.09);
  transition: box-shadow .1s ease-in-out;
}


`, "",{"version":3,"sources":["webpack://./src/Dashboard.css"],"names":[],"mappings":"AAEA;EACE,aAAa,EAAE,mBAAmB;EAClC,8BAA8B;AAChC;;AAEA;EACE,SAAO,EAAE,oDAAoD;EAC7D,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,wCAAwC,EAAE,wCAAwC;EAClF,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,SAAS,EAAE,iCAAiC;EAC5C,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,SAAS,EAAE,+CAA+C;EAC1D,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,gDAAgD,EAAE,yCAAyC;AAC7F;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,wCAAwC,EAAE,wCAAwC;EAClF,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,0BAA0B;EAC1B,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,SAAS,EAAE,+CAA+C;EAC1D,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,gDAAgD,EAAE,yCAAyC;AAC7F;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,yCAAyC,EAAE,sCAAsC;EACjF,wBAAwB,EAAE,eAAe;AAC3C;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB,EAAE,mCAAmC;AAC1D;;AAEA;EACE,sCAAsC,EAAE,0BAA0B;EAClE,6CAA6C,EAAE,qCAAqC;EACpF,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB,EAAE,sCAAsC;EACxD,kCAAkC;EAClC,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,4DAA4D;EAC5D,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,4CAA4C;EAC5C,uCAAuC;EACvC,sCAAsC;AACxC","sourcesContent":["@import './variables.css';\n\n.blob-actions-container {\n  display: flex; /* Enable flexbox */\n  justify-content: space-between;\n}\n\n.blob-action-button {\n  flex: 1; /* Allow children to grow and fill available space */\n  margin-top: 10px;\n  background: var(--hover-color);\n  position: relative;\n}\n\n.blob-action-button:hover {\n  background: var(--secondary-color);\n}\n\n#blob-download-button {\n  margin-left: 10px;\n}\n\n.generate-button-container {\n  position: relative;\n  display: inline-block;\n  cursor: pointer;\n  width: 100%; \n  margin-bottom: 5px;\n}\n\n.generate-button-container .tooltip {\n  visibility: hidden;\n  width: 220px;\n  background-color: var(--highlight-color); /* Purple background like in the image */\n  color: var(--background-color);\n  text-align: center;\n  border-radius: 6px;\n  padding: 10px;\n  position: absolute;\n  z-index: 1;\n  top: 130%; /* Position it below the button */\n  left: 83%;\n  transform: translateX(-50%);\n  opacity: 0;\n  transition: opacity 0.3s;\n}\n\n.generate-button-container .tooltip-caret {\n  position: absolute;\n  top: -6px; /* Position the caret right below the tooltip */\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  border-bottom: 10px solid var(--highlight-color); /* Same color as the tooltip background */\n}\n\n.generate-button-container:hover .tooltip {\n  visibility: visible;\n  opacity: 1;\n}\n\n.blob-action-button .tooltip {\n  visibility: hidden;\n  width: 220px;\n  background-color: var(--highlight-color); /* Purple background like in the image */\n  color: var(--background-color);\n  text-align: center;\n  border-radius: 6px;\n  padding: 10px;\n  position: absolute;\n  z-index: 1;\n  top: 130%; \n  transform: translateX(15%);\n  opacity: 0;\n  transition: opacity 0.3s;\n}\n\n.blob-action-button .tooltip-caret {\n  position: absolute;\n  top: -6px; /* Position the caret right below the tooltip */\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  border-bottom: 10px solid var(--highlight-color); /* Same color as the tooltip background */\n}\n\n.blob-action-button:hover .tooltip {\n  visibility: visible;\n  opacity: 1;\n}\n\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Loading Animation Container */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 90vh;\n  background-color: var(--background-color); /* Adjust background color as needed */\n  color: var(--text-color); /* Text color */\n}\n\n.loading-text {\n  font-size: 1.5rem;\n  text-align: center;\n  font-family: 'Eastlane Medium', sans-serif;\n  margin-bottom: 30px; /* Space between text and spinner */\n}\n\n.spinner {\n  border: 8px solid var(--primary-color); /* Light grey background */\n  border-top: 8px solid var(--background-color); /* Blue color for the spinning part */\n  border-radius: 50%;\n  width: 60px;\n  height: 60px;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.loading-subtext {\n  font-size: 1.2rem;\n  margin-top: 20px; /* Space between spinner and subtext */\n  color: var(--secondary-text-color);\n  text-align: center;\n  font-family: \"Riforma Regular\", \"Montserrat\", sans-serif; \n}\n\n.fyMonth {\n  float: right;\n  color: var(--highlight-color);\n  font-family: \"Riforma Bold Italic\", \"Montserrat\", sans-serif; \n  font-weight: 800;\n}\n\n.model-generator-container {\n  padding: 35px;\n  border-radius: 20px;\n  background: var(--tertiary-background-color);\n  box-shadow: 0 2px 7px 0 rgba(0,0,0,.09);\n  transition: box-shadow .1s ease-in-out;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
